export const gridViewConfigFields = `
  id
  kind
  organizationID
  scopeKey
  userID
  name
  description
  selectedViewRef
  payload
  draftPayload
  payloadVersion
  gridSchemaVersion
  status
  isDefault
  createdByUserID
  updatedByUserID
  createdAt
  updatedAt
  revision
  source
`

export const gridViewConfigByOrganizationScopeQuery = /* GraphQL */ `
  query GridViewConfigByOrganizationScope($organizationID: ID!, $scopeKey: String!, $limit: Int, $nextToken: String, $sortDirection: ModelSortDirection, $filter: ModelGridViewConfigFilterInput) {
    gridViewConfigByOrganizationScope(
      organizationID: $organizationID
      scopeKeyKindUpdatedAt: { beginsWith: { scopeKey: $scopeKey, kind: TEAM_VIEW } }
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      filter: $filter
    ) {
      items { ${gridViewConfigFields} }
      nextToken
    }
  }
`

export const getGridViewConfigQuery = /* GraphQL */ `
  query GetGridViewConfig($id: ID!) {
    getGridViewConfig(id: $id) {
      ${gridViewConfigFields}
    }
  }
`
